import { Navigate } from 'react-router-dom'
import { useAuthentication } from '../contexts/AuthenticationContext.tsx'
import { Flex, Spinner } from '@radix-ui/themes'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, isLoading } = useAuthentication()

  if (isLoading) {
    return (
      <Flex align="center" justify="center" style={{ minHeight: '200px' }}>
        <Spinner />
      </Flex>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}